// src/app/project-bid.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProjectBid } from '../objects/ProjectBid';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProjectBidService {
   private apiUrl = environment.apiUrl +'ProjectBids'; // Replace with your API endpoint

  constructor(private http: HttpClient) {}

  getProjectBids(): Observable<ProjectBid[]> {
    return this.http.get<ProjectBid[]>(this.apiUrl);
  }

  getProjectBidById(id: number): Observable<ProjectBid> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<ProjectBid>(url);
  }

  addProjectBid(projectBid: ProjectBid): Observable<ProjectBid> {
    return this.http.post<ProjectBid>(this.apiUrl, projectBid);
  }

  editProjectBid(projectBid: ProjectBid): Observable<ProjectBid> {
    const url = `${this.apiUrl}/${projectBid.id}`;
    return this.http.put<ProjectBid>(url, projectBid);
  }
}
